let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("3lsfR")).then(() => parcelRequire('8aLn9'));